<div ngClass="heads-up">
  <!-- Monthly reaching CAP -->
  <div ngClass="heads-up__warning" *ngIf="defineOrder(1)">
    <span>
      <strong>Monthly cap</strong>:
      {{ maxMonthly - currentMontlhy | currency: currency }} remaining out of
      {{ maxMonthly | currency: currency }}.
    </span>
    <a routerLink="/my-account/take-control-of-your-play">Manage</a>
  </div>

  <!-- Monthly exceed CAP-->
  <div ngClass="heads-up__error" *ngIf="defineOrder(2)">
    <span> <strong> Monthly cap reached</strong>: It resets next month.</span>
    <a routerLink="/my-account/take-control-of-your-play">Manage</a>
  </div>

  <!-- Heads up -->
  <div ngClass="heads-up__normal" *ngIf="defineOrder(3)">
    <span>
      <strong> Heads up</strong>: you've spent
      <strong>{{ current | currency: currency }}</strong> this session.
    </span>
    <a href="" routerLink="/my-account/take-control-of-your-play">Set limit</a>
  </div>
</div>
